import { render, staticRenderFns } from "./AssignAuthorityModal.vue?vue&type=template&id=e3307660&scoped=true"
import script from "./AssignAuthorityModal.vue?vue&type=script&lang=js"
export * from "./AssignAuthorityModal.vue?vue&type=script&lang=js"
import style0 from "./AssignAuthorityModal.vue?vue&type=style&index=0&id=e3307660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3307660",
  null
  
)

export default component.exports